// Modal.js
import React from 'react';
import close from "../assets/close.svg";
import { useModal } from './../providers/ModalContext';
import Rules from './../pages/rules';
import Conditions from './../pages/conditions';
import Gdpr from '../pages/gdpr';

const Modal = () => {
    const { isVisible, closeModal, currentPage } = useModal();

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 z-50 bg-petrol-500 w-full h-full max-h-full">
            <div
                className="z-50 absolute ml-auto h-6 w-6 cursor-pointer right-6 top-6"
                onClick={() => closeModal()}
            >
                <img src={close} className="close-icon" alt="close menu" />
            </div>

            <div className="flex justify-center w-full v-h-full max-h-full overflow-auto">
                {currentPage === "Rules" && <Rules noNav={true} />}
                {currentPage === "Conditions" && <Conditions noNav={true} />}
                {currentPage === "Gdpr" && <Gdpr noNav={true} />}
            </div>



        </div>
    );
};
export default Modal;